// extracted by mini-css-extract-plugin
module.exports =  {"button":"_93444fe79c--button--GVLSF","dark":"_93444fe79c--dark--gen_X"};